import type { Survey, TourStopsResponse } from "@/features/survey/types";
import { interactiveSurveyApi } from "./base";

// Interactive Survey API for authenticated survey operations
export const interactiveSurveyDetailsApi = interactiveSurveyApi
  .enhanceEndpoints({
    addTagTypes: ["InteractiveSurvey"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getSurveyDetails: build.query<Survey, string>({
        query: (surveyId) => ({
          url: `/survey/${surveyId}`,
        }),
        providesTags: (_result, _error, surveyId) => [
          { type: "InteractiveSurvey", id: surveyId },
        ],
      }),
      getTourStops: build.query<TourStopsResponse, string>({
        query: (surveyId) => ({
          url: `/tour-stops/${surveyId}`,
        }),
        transformResponse: (response: any): TourStopsResponse => {
          // Normalize response structure - API returns { stops: [...] }
          if (Array.isArray(response)) {
            return { stops: response };
          }
          return {
            stops: response?.stops ?? response?.tourStops ?? response?.data ?? [],
            tourStops: response?.tourStops,
            data: response?.data,
          };
        },
        providesTags: (_result, _error, surveyId) => [
          { type: "InteractiveSurvey", id: `${surveyId}-tour-stops` },
        ],
      }),
    }),
  });

export const { 
  useGetSurveyDetailsQuery,
  useGetTourStopsQuery,
} = interactiveSurveyDetailsApi;
